<div class="search-page">
    <div class="container">

    @if (!error) {

        <div class="search-shell">
            <div class="search-hero">
                <div class="search-copy">
                    <h1>{{ 'SEARCH.TITLE' | translate }}</h1>
                    <p class="intro">{{ 'SEARCH.DESCRIPTION' | translate }}</p>
                    <div class="header">
                        <div class="search-field">
                            <mat-form-field appearance="outline" class="search-text">
                                <mat-label>{{ 'SEARCH.HINT' | translate }}</mat-label>

                                <input
                                        matInput
                                        [(ngModel)]="searchText"
                                        type="text"
                                />

                                @if (hasSearchText()) {
                                    <button
                                            mat-icon-button
                                            matSuffix
                                            type="button"
                                            aria-label="Clear"
                                            (click)="searchText = ''">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                }
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="search-visual" aria-hidden="true">
                    <img alt="" src="assets/images/search/title_moon.webp">
                </div>
            </div>

            <div class="results-card">
                <app-task-list [searchText]="searchText"></app-task-list>
            </div>
        </div>
    }

    @if (error) {
        <div>
            <app-error></app-error>
        </div>
    }
    </div>
</div>
